import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LocalesType } from 'constants/locales';

import { languageInitialState } from './constants';

const languageSlice = createSlice({
  name: 'language',
  initialState: languageInitialState,
  reducers: {
    switchInterfaceLanguage: (state, action: PayloadAction<LocalesType>) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { switchInterfaceLanguage } = languageSlice.actions;

export default languageSlice.reducer;
